<template>
	<div class="contianer">
    <head class="title">双十二超级红包</head>
    <div class="content">
      <img class="img" :src="pic_url" alt="">
      <div class="taoword" data-clipboard-text="">{{taoword}}</div>
      <div class="copy_box">
        <div type="button" v-bind:class="{ active: isActive, 'copy': true }" @click="buttonAction">{{copy_txet}}</div>
        <div class="copy_tip">
          <span>长按框内</span>
          <span class="jtone"></span>
          <span>全选</span>
          <span class="jttwo"></span>
          <span>复制</span>
          <span class="jtthree"></span>
          <span class="jt4"><img src="https://pic.kuaizhan.com/g3/ba/35/9ec3-520f-471d-834b-6410aa24ef0315" style="width: 18px;">打开手机Tao宝</span>
        </div>
      </div>
    </div>
    <!-- <div class="dialog" v-if="dialog_show">
      <div class="dialog_head" >复制成功！</div>
      <div class="dialog__message dialog__message--has-title" style="font-size:18px;font-weight:bold;color:#ff4a44">
        赶紧打开
        <span style="font-size:25px;font-weight:bold;color:#ff4a44"> 手机淘宝 </span>
        查看红包
      </div>
    </div>
    <div v-if="overlay_show" class="overlay" id="bg" style="z-index: 2002;"></div> -->
  </div>
</template>
<script>
export default {
  created() {
    console.log(this.$route.query);
    this.taoword = `8.0${this.$route.query.taoword || "口令出错"}//`;
    this.pic_url = this.$route.query.pic_url;
  },
  data() {
    return {
      overlay_show: false,
      dialog_show: false,
      isActive: false,
      copy_txet: "一键复制",
      taoword: "口令未显示",
      pic_url: "https://img.alicdn.com/imgextra/i2/880734502/O1CN01QGsDv11j7xj8NlHMd_!!880734502.jpg"
    }
  },
  methods: {
    buttonAction() {
      this.isActive = true;
      this.copy_txet = "复制成功，打开淘宝查看！！！";
      this.copy(this.taoword)
      const _this = this;
      setTimeout(() => {
        _this.isActive = false;
        _this.copy_txet = "一键复制";
      }, 1500);

      
    },

    copy(txet) {
      let transfer = document.createElement('input');
      document.body.appendChild(transfer);
      transfer.value = txet;  // 这里表示想要复制的内容
      transfer.focus();
      transfer.select();
      if (document.execCommand('copy')) {
          document.execCommand('copy');
      }
      transfer.blur();
      console.log('复制成功');
      document.body.removeChild(transfer);
    }
  }
}
</script>
<style scoped>
  .container {
    width: 100%;
  }
  .title {
    font-size: 18px;
    vertical-align: top;
    display: inline-block;
    color: #FFF;
    text-overflow: ellipsis;
    word-break: break-all;
    white-space: nowrap;
    overflow: hidden;
    background: linear-gradient(20deg, #ff9700, #ed1c24);
    height: 45px;
    line-height: 45px;
    position: relative;
    top: 0;
    text-overflow: ellipsis;
    word-break: break-all;
    white-space: nowrap;
    overflow: hidden;
    width: 100%;
    text-align: center;
  }

  .img {
    box-shadow: 0px 0.25rem 0.5rem rgba(70, 70, 70, .3);
    width: 100%;
    margin-bottom: 20px;
    border: 0.125rem solid #e4e7ea;
    border-radius: 0.625rem;
    margin-top: 20px;
  }

  .copy_box {
    margin: 14px;
    margin-top: 16px;
    text-align: center;
  }

  .taoword {
    background: white;
    border: 1px dashed #fb6a65;
    padding: 10px;
    border-radius: 5px;
    text-align: center;
    margin: 0 10px 0 10px;
  }
  .copy {
    background: linear-gradient(20deg, #ff9700, #ed1c24);
    border-radius: 5px;
    color: white;
    font-size: 14px;
    margin: 16px auto;
    padding: 10px;
    margin-bottom: 2px;
    cursor: pointer;
  }

  .active {
    background: cornflowerblue;
  }

  .copy_tip {
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: linear-gradient(to right, #f9c492, #fb6a65);
    color: white;
    font-size: 12px;
    height: 24px;
  }
  .copy_tip .jtone {
    position: relative;
    width: 0;
    height: 0;
    border-top: 12px solid transparent;
    border-left: 10px solid white;
    border-bottom: 12px solid transparent;
  }
  .jtone::before {
    content: "";
    position: absolute;
    top: -12px;
    left: -13px;
    width: 0;
    height: 0;
    border-top: 12px solid transparent;
    border-left: 10px solid #fab189;
    border-bottom: 12px solid transparent;
  }
  .jttwo {
    position: relative;
    width: 0;
    height: 0;
    border-top: 12px solid transparent;
    border-left: 10px solid white;
    border-bottom: 12px solid transparent;
  }
  .jttwo::before {
    content: "";
    position: absolute;
    top: -12px;
    left: -13px;
    width: 0;
    height: 0;
    border-top: 12px solid transparent;
    border-left: 10px solid #fa9b7e;
    border-bottom: 12px solid transparent;
  }
  .jtthree {
    position: relative;
    width: 0;
    height: 0;
    border-top: 12px solid transparent;
    border-left: 10px solid white;
    border-bottom: 12px solid transparent;
  }
  .jtthree::before {
    content: "";
    position: absolute;
    top: -12px;
    left: -13px;
    width: 0;
    height: 0;
    border-top: 12px solid transparent;
    border-left: 10px solid #fa8673;
    border-bottom: 12px solid transparent;
  }
  .jt4 {
    display: flex;
    align-items: center;
  }
  .dialog {
    padding: 10px;
    position: fixed;
    top: 45%;
    left: 50%;
    width: 85%;
    overflow: hidden;
    font-size: 16px;
    background-color: #fff;
    border-radius: 6px;
    -webkit-transform: translate3d(-50%,-50%,0);
    z-index: 2202;
  }
  .dialog_head {
    text-align: center;
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: bold;
  }
  .dialog_message {
    font-size: 18px;
    font-weight: bold;
    color: #ff4a44;
    text-align: center;
    margin-top: 10px;
  }
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.7);
  }
</style>


// WEBPACK FOOTER //
// src/view/taoword/index.vue